// src/Pages/CouponList/index.jsx

import React, { useState, useEffect } from "react";
import { Flex, Select, Tag } from "antd";
import { useQuery } from "@tanstack/react-query";
import DebouncedInput from "../../Component/DebouncedInput";
import CustomTable from "../../Component/Table";
import { FilterContainer } from "../../Styles/filterStyle";
import { getAllCoupons } from "../../Services/coupon";
import { formatDate } from "../../utils/date";

const columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Coupon Code", dataIndex: "code", key: "code" },
    // { title: "Plan Name", dataIndex: "plan_name", key: "plan_name", render: (text) => text || "-" },
    // { title: "Plan Slug", dataIndex: "plan_slug", key: "plan_slug", render: (text) => text || "-" },
    { title: "Description", dataIndex: "description", key: "description", render: (text) => text || "-" },
    {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        render: (is_active) => (
            <Tag color={is_active ? "green" : "red"}>
                {is_active ? "Active" : "Disabled"}
            </Tag>
        ),
    },
    {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        render: (text) => (text ? formatDate(text) : "-"),
    },
];

const CouponList = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const skip = (currentPage - 1) * pageSize;

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, selectedStatus]);

    const { data, isLoading } = useQuery({
        queryKey: ["coupons", currentPage, pageSize, searchTerm, selectedStatus],
        queryFn: () =>
            getAllCoupons({
                name: searchTerm,
                isActive: selectedStatus,
                skip,
                limit: pageSize,
            }),
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
    });

    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    return (
        <div>
            <Flex justify="space-between" align="center">
                <h3>Coupon List</h3>
            </Flex>

            <br />

            <FilterContainer>
                <DebouncedInput
                    placeholder="Search by Code or Plan..."
                    value={searchTerm}
                    onChange={setSearchTerm}
                    delay={1000}
                    width={220}
                />

                <Select
                    allowClear
                    placeholder="Select Status"
                    style={{ width: 140 }}
                    value={selectedStatus}
                    onChange={setSelectedStatus}
                    options={[
                        { label: "Active", value: true },
                        { label: "Disabled", value: false },
                    ]}
                />
            </FilterContainer>

            <CustomTable
                columns={columns}
                data={data?.coupons || []}
                loading={isLoading}
                pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: data?.total_count || 0,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                    position: ["bottomRight"],
                }}
                onTableChange={handleTableChange}
                maxHeight="calc(100vh - 300px)"
            />
        </div>
    );
};

export default CouponList;
